<div class="loading" *ngIf="loading">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div class="resumo-grid" *ngIf="resumo" aria-live="polite">

  <div class="topo-row">
    <!-- DADOS DO CONCURSO -->
    <mat-card>
      <mat-card-content>
        <a class="card-title card-link" routerLink="../dados"><mat-icon aria-hidden="true">info</mat-icon> Dados do Concurso</a>
        <div class="dados-resumo">
          <div class="dado-item"><span class="dado-label">Processo</span><span class="dado-valor">{{ resumo.processo }}</span></div>
          <div class="dado-item"><span class="dado-label">Tipo</span><span class="dado-valor">{{ resumo.tipo }}</span></div>
          <div class="dado-item"><span class="dado-label">Unidade</span><span class="dado-valor">{{ resumo.siglaUnidade }}</span></div>
          <div class="dado-item"><span class="dado-label">Período de Inscrição</span><span class="dado-valor">{{ resumo.inicio }} a {{ resumo.fim }}</span></div>
          <div class="dado-item" *ngIf="resumo.dataPublicacaoDoe"><span class="dado-label">Data de publicação no DOE</span><span class="dado-valor">{{ resumo.dataPublicacaoDoe }}</span></div>
          <div class="dado-item"><span class="dado-label">Fase Atual</span><span class="dado-valor">{{ formatFase(resumo.faseAtual) }}</span></div>
          <div class="dado-item"><span class="dado-label">Andamento Vigente</span><span class="dado-valor">{{ resumo.andamentoVigente || '—' }}</span></div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- STEPPER -->
    <mat-card>
      <mat-card-content>
        <h2 class="card-title"><mat-icon aria-hidden="true">route</mat-icon> Etapas do Concurso</h2>

        <div class="stepper-h" role="tablist" aria-label="Etapas do concurso">
          <div class="step-h" *ngFor="let step of steps; let i = index"
               [class.completed]="step.state === 'completed'"
               [class.active]="step.state === 'active'"
               [class.pending]="step.state === 'pending'"
               [class.selected]="i === selectedStep"
               role="tab"
               [attr.aria-selected]="i === selectedStep"
               [attr.aria-label]="step.label + ' — ' + step.state"
               tabindex="0"
               (click)="showDetail(i)"
               (keydown)="onStepKeydown($event, i)">
            <div class="step-h-icon">
              <mat-icon *ngIf="step.state === 'completed'" aria-hidden="true">check</mat-icon>
              <mat-icon *ngIf="step.state === 'active'" aria-hidden="true">play_arrow</mat-icon>
              <mat-icon *ngIf="step.state === 'pending'" aria-hidden="true">radio_button_unchecked</mat-icon>
            </div>
            <span class="step-h-label">{{ step.label }}</span>
          </div>
        </div>

        <div class="step-detail-panel" role="tabpanel" [attr.aria-label]="steps[selectedStep].title">
          <h3 class="step-detail-title">{{ steps[selectedStep].title }}</h3>
          <ul class="step-detail-list">
            <li *ngFor="let item of steps[selectedStep].items" [ngClass]="item.status">
              <mat-icon aria-hidden="true" *ngIf="item.status === 'done'">check_circle</mat-icon>
              <mat-icon aria-hidden="true" *ngIf="item.status === 'action'">warning</mat-icon>
              <mat-icon aria-hidden="true" *ngIf="item.status === 'pending'">radio_button_unchecked</mat-icon>
              <span>{{ item.text }}</span>
            </li>
          </ul>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- INSCRIÇÕES -->
  <mat-card>
    <mat-card-content>
      <a class="card-title card-link" routerLink="../inscricoes"><mat-icon aria-hidden="true">how_to_reg</mat-icon> Inscrições</a>
      <div class="inscricoes-grid">
        <div class="inscricoes-stats">
          <div class="stat-total">{{ resumo.totalInscricoes }}</div>
          <div class="stat-row" *ngFor="let key of inscricoesLabels">
            <span class="stat-label"><span class="stat-dot" [style.background]="getStatusColor(key)"></span>{{ formatStatus(key) }}</span>
            <div class="stat-bar-wrapper">
              <div class="stat-bar" [style.width.%]="getPercent(resumo.inscricoesPorStatus[key], resumo.totalInscricoes)" [style.background]="getStatusColor(key)"></div>
            </div>
            <strong>{{ resumo.inscricoesPorStatus[key] }}</strong>
          </div>
        </div>
        <div class="inscricoes-chart">
          <canvas #chartInscricoes aria-label="Gráfico de inscrições por status" role="img"></canvas>
        </div>
        <div class="inscricoes-indicators">
          <div class="indicator-item"><mat-icon>description</mat-icon> Completas: <strong>{{ resumo.inscricoesCompletas }}/{{ resumo.totalInscricoes }}</strong></div>
          <div class="indicator-item"><mat-icon>accessible</mat-icon> PCD: <strong>{{ resumo.inscricoesPcd }}</strong></div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- COMISSÃO -->
  <mat-card>
    <mat-card-content>
      <a class="card-title card-link" routerLink="../examinadores"><mat-icon aria-hidden="true">groups</mat-icon> Comissão Julgadora</a>
      <div class="comissao-chart" aria-label="Composição da comissão julgadora">
        <canvas #chartComissao role="img" aria-label="Gráfico de barras da comissão: preenchidos vs necessários"></canvas>
      </div>
      <div class="comissao-indicators">
        <div class="comissao-indicator">
          <span class="comissao-indicator-label">Declarações assinadas</span>
          <div class="progress-bar-inline">
            <div class="progress-bar-fill" [class.complete]="resumo.comissaoAssinaram >= resumo.comissaoTotalAtivos && resumo.comissaoTotalAtivos > 0" [style.width.%]="getPercent(resumo.comissaoAssinaram, resumo.comissaoTotalAtivos)"></div>
          </div>
          <span class="progress-text">{{ resumo.comissaoAssinaram }}/{{ resumo.comissaoTotalAtivos }}</span>
        </div>
        <div class="comissao-indicator">
          <span class="comissao-indicator-label">Notificados</span>
          <div class="progress-bar-inline">
            <div class="progress-bar-fill" [class.complete]="resumo.comissaoNotificados >= resumo.comissaoTotalAtivos && resumo.comissaoTotalAtivos > 0" [style.width.%]="getPercent(resumo.comissaoNotificados, resumo.comissaoTotalAtivos)"></div>
          </div>
          <span class="progress-text">{{ resumo.comissaoNotificados }}/{{ resumo.comissaoTotalAtivos }}</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- RECURSOS -->
  <mat-card>
    <mat-card-content>
      <a class="card-title card-link" routerLink="/recurso" (click)="salvarContextoRecursos()"><mat-icon aria-hidden="true">gavel</mat-icon> Recursos ({{ resumo.totalRecursos }})</a>
      <div class="recursos-grid" *ngIf="resumo.totalRecursos > 0">
        <div class="recursos-chart">
          <canvas #chartRecursosStatus aria-label="Gráfico de recursos por status" role="img"></canvas>
        </div>
        <div class="recursos-chart">
          <canvas #chartRecursosTipo aria-label="Gráfico de recursos por tipo" role="img"></canvas>
        </div>
      </div>
      <p *ngIf="resumo.totalRecursos === 0" class="no-data">Nenhum recurso registrado.</p>
    </mat-card-content>
  </mat-card>

  <!-- SIGAD -->
  <mat-card>
    <mat-card-content>
      <a class="card-title card-link" routerLink="../processo-digital"><mat-icon aria-hidden="true">cloud_upload</mat-icon> Processo Digital (SIGAD)</a>
      <div class="sigad-progress">
        <div class="sigad-gauge-wrapper">
          <div class="sigad-gauge">
            <canvas #chartSigad role="img" aria-label="Progresso de envios ao SIGAD"></canvas>
          </div>
          <div class="sigad-gauge-label">{{ sigadEnviados }}/{{ resumo.enviosSigad.length }} enviados</div>
        </div>
        <div class="sigad-list">
          <div class="sigad-item" *ngFor="let envio of resumo.enviosSigad">
            <mat-icon [class.done]="envio.enviados >= envio.total && envio.total > 0" [class.pendente]="envio.enviados < envio.total || envio.total === 0" aria-hidden="true">
              {{ envio.enviados >= envio.total && envio.total > 0 ? 'check_circle' : 'radio_button_unchecked' }}
            </mat-icon>
            <span class="sigad-item-label">{{ envio.descricao }}</span>
            <div class="progress-bar-inline sigad-bar">
              <div class="progress-bar-fill" [class.complete]="envio.enviados >= envio.total && envio.total > 0" [style.width.%]="getPercent(envio.enviados, envio.total)"></div>
            </div>
            <span class="progress-text">{{ envio.enviados }}/{{ envio.total }}</span>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="provas-row">
  <!-- PROVAS -->
  <mat-card >
    <mat-card-content>
      <a class="card-title card-link" routerLink="../provas"><mat-icon aria-hidden="true">assignment</mat-icon> Provas e Notas</a>
      <table class="provas-table" aria-label="Tabela de provas e notas">
        <caption class="visually-hidden">Status das provas do concurso</caption>
        <thead>
          <tr>
            <th scope="col">Prova</th>
            <th scope="col">Fase</th>
            <th scope="col" class="text-center">Notas</th>
            <th scope="col" class="text-center">Envelopes</th>
            <th scope="col" class="text-center">Presença</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let prova of resumo.provas">
            <td>{{ prova.nome }}</td>
            <td>{{ formatFase(prova.fase) }}</td>
            <td>
              <div class="progress-cell" *ngIf="prova.totalNotas > 0">
                <div class="progress-bar-inline">
                  <div class="progress-bar-fill" [class.complete]="prova.notasLancadas >= prova.totalNotas" [style.width.%]="getPercent(prova.notasLancadas, prova.totalNotas)"></div>
                </div>
                <span class="progress-text">{{ prova.notasLancadas }}/{{ prova.totalNotas }}</span>
              </div>
              <span *ngIf="prova.totalNotas === 0" class="status-none">—</span>
            </td>
            <td>
              <div class="progress-cell" *ngIf="prova.totalEnvelopes > 0">
                <div class="progress-bar-inline">
                  <div class="progress-bar-fill" [class.complete]="prova.envelopesEnviados >= prova.totalEnvelopes" [style.width.%]="getPercent(prova.envelopesEnviados, prova.totalEnvelopes)"></div>
                </div>
                <span class="progress-text">{{ prova.envelopesEnviados }}/{{ prova.totalEnvelopes }}</span>
              </div>
              <span *ngIf="prova.totalEnvelopes === 0" class="status-none">—</span>
            </td>
            <td>
              <div class="progress-cell" *ngIf="prova.totalPresenca > 0">
                <div class="progress-bar-inline">
                  <div class="progress-bar-fill complete" [style.width.%]="getPercent(prova.presencaRegistrada, prova.totalPresenca)"></div>
                </div>
                <span class="progress-text">{{ prova.presencaRegistrada }}/{{ prova.totalPresenca }}</span>
              </div>
              <span *ngIf="prova.totalPresenca === 0" class="status-none">—</span>
            </td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="resumo.provas.length === 0" class="no-data">Nenhuma prova configurada.</p>
    </mat-card-content>
  </mat-card>


  <!-- PROVAS DIGITALIZADAS -->
  <mat-card>
    <mat-card-content>
      <a class="card-title card-link" routerLink="../documentos"><mat-icon aria-hidden="true">scanner</mat-icon> Provas Digitalizadas</a>
      <div class="digitalizacao-content">
        <div class="digitalizacao-gauge">
          <canvas #chartDigitalizacao role="img" aria-label="Progresso de digitalização de provas"></canvas>
        </div>
        <div class="digitalizacao-label">{{ resumo.provasDigitalizadas }}/{{ resumo.provasDigitalizadasTotal }}</div>
      </div>
    </mat-card-content>
  </mat-card>

  </div>
  <!-- CLASSIFICAÇÃO -->
  <mat-card class="full-width">
    <mat-card-content>
      <a class="card-title card-link" routerLink="../classificacao"><mat-icon aria-hidden="true">leaderboard</mat-icon> Resultado por Fase</a>
      <div class="classificacao-chart">
        <canvas #chartClassificacao role="img" aria-label="Gráfico de classificação por fase"></canvas>
      </div>
    </mat-card-content>
  </mat-card>

</div>
